module.exports = __webpack_public_path__ + "img/JCB.15c05fcf.png";